import { format } from 'date-fns'

import { CHARACTER_WHITESPACE } from '../../../../../../constants/common'
import { DATE_FULL_FORMAT } from '../../../../../../constants/date'
import { toUkTimezoneDate } from '../../../../../../utils/date'
import { getListingPublicationErrorText } from '../../../../../RentalPortalListing'

export function getListingPublicationErrorDescription({
  publication,
  t,
  timezone,
}) {
  const lines = [getListingPublicationErrorText({ publication, t })]

  if (publication.last_action_at) {
    lines.push(
      t('RentalPortal.ListingPublicationErrorLastAttemptKey', {
        datetime: format(
          toUkTimezoneDate(publication.last_action_at, timezone),
          DATE_FULL_FORMAT
        ),
      })
    )
  }

  return lines.join(CHARACTER_WHITESPACE)
}
